import type { IValues } from '../valuesTypes';
import { allowedFileTypes } from '../../../tools/utils';

import classNames from 'classnames';

import { useFormikContext } from 'formik';
import { useState, useMemo } from 'react';
import { screenedValues } from '../../../tools/constants';
import { useTranslation } from 'react-i18next';

export const LocationSitePlan = ({
    handler,
    editable = true,
}: {
    handler?: (step: number) => void;
    editable?: boolean;
}) => {
    const { t} = useTranslation();
    const { values, errors, touched, submitCount } = useFormikContext<IValues>();

    const [isExpanded, setIsExpanded] = useState(false);

    const isFormCompleted = useMemo(
        () => screenedValues[2].every(field => !errors[field] && touched[field]),
        [errors, touched]
    );

    return (
        <div
            className={classNames('cco_collapse', {
                active: isExpanded,
            })}
        >
            <div className="cco_collapse_header">
                <div className="cco_text cco_text_3">
                    <div className="cco_text_inner">
                        <h3>3. {t("NewLocation.LocationSitePlan.LocationSitePlan")}</h3>

                        <div
                            className={classNames({
                                success: isFormCompleted,
                                error: !isFormCompleted,
                            })}
                        >
                            {isFormCompleted
                                ? t("NewLocation.LocationSitePlan.Completed")
                                : submitCount < 1
                                    ? t("NewLocation.LocationSitePlan.InProgress")
                                    : t("NewLocation.LocationSitePlan.fill")}
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    className="cco_collapse_toggle"
                    onClick={() => setIsExpanded(prevState => !prevState)}
                >
                    <span className="cco_collapse_toggle_text">{t("NewLocation.LocationSitePlan.View")}</span>
                </button>
            </div>

            <div className="cco_collapse_body">
            {'string' === typeof values.sitePlan &&
                                    values.sitePlan &&(
    <div >
        { values.sitePlan.includes('sharepoint') || values.sitePlan.includes('.pdf')  ? (
            <div className="cco_btn cco_btn_2">
            <a
            
                href={values.sitePlan}
                target="_blank"
                rel="noopener noreferrer"
              
            >
                Open
            </a>
            </div>
        ) : null}
    </div>
)}
                <div className="cco_collapse_body_inner">
              
      
                    <div className="cco_blurb cco_blurb_2">
                        <div className="cco_blurb_img">
                            {(values.sitePlan instanceof File && values.sitePlan.type.includes('image')) ||
                                ('string' === typeof values.sitePlan &&
                                    values.sitePlan &&
                                    !values.sitePlan.includes('.pdf')) && !values.sitePlan.includes('sharepoint') ? (
                                <img
                                    onLoad={e => {
                                        const src = e.currentTarget.src;

                                        if (src.startsWith('blob:')) URL.revokeObjectURL(src);
                                    }}
                                    src={
                                        values.sitePlan instanceof File
                                            ? URL.createObjectURL(values.sitePlan)
                                            : values.sitePlan
                                    }
                                    alt="Site Plan"
                                />
                            ) : (
                                <span className="cco_blurb_img_icon cco_blurb_img_icon_file" />
                            )}     
                        </div>


        {values.sitePlan && (
                            <div className="cco_blurb_title">
                                {(values.sitePlan instanceof File && allowedFileTypes.includes(values.sitePlan.type)) ? values.sitePlan.name : null /* values.sitePlan */}
                                {(editable && !allowedFileTypes.includes(values.sitePlan.type))?(<p className='cco_blurb cco_blurb_error cco_blurb_3'>File type not supported.</p>):(null)}
                            </div>
                        )}
                    </div>

                    {editable && (
                        <div className="cco_btn cco_btn_2">
                            <a
                                href="#"
                                onClick={e => {
                                    handler?.(2);
                                    e.preventDefault();
                                }}
                            >
                                {t("NewLocation.LocationSitePlan.Edit")}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
